import React from 'react'
import { ArrowRightIcon } from '../../../conf/images'
import './KnowledgeCell.css'
import { KnowledgeModel } from '../../../model/knowledge.model'

interface KnowledgeCellProps {
    dataSource?: KnowledgeModel
    onClick?: () => void
    onStatusChange?: (checked: boolean) => void
}
const KnowledgeCell: React.FC<KnowledgeCellProps> = (props) => {
    const { dataSource, onClick } = props
    if (!dataSource) return null
    return (
        <div className='bot-knowledge-cell' onClick={onClick}>
            <p
                className='knowledge-cell__title ellipsis'
                dangerouslySetInnerHTML={{
                    __html: dataSource.k_title,
                }}
            >
                {/* {dataSource.k_title} */}
            </p>
            <div className='knowledge-cell-right'>
                <span className={`status status-${dataSource.status}`}>
                    {dataSource.status === 1 ? '已生效' : '未生效'}
                </span>
                <img
                    className='knowledge-cell__arrow icon24'
                    src={ArrowRightIcon}
                    alt='>'
                />
            </div>
        </div>
    )
}

export default KnowledgeCell
